<template>
    <div class="customerreporth3wrapper">
        <form-checkbox
            label="Case Study Highlight"
            field-name="submit_invoices_case_study_checkbox"
            v-model="checkboxValue"
            class="border-b-4"
        ></form-checkbox>
    </div>
</template>
<script>
export default {
    props: {
        project: {
            required: true,
            type: Object,
        },
        phase: {
            required: true,
            type: Object,
        }
    },
    data() {
        return {
            watcher: null,
            checkboxValue: this.project.case_study === 1
        }
    },

    created() {
        this.setupWatcher();
    },

    methods: {
        setupWatcher() {
            this.watcher = this.$watch('checkboxValue', (newValue) => {
                this.updateValue(newValue)
            })
        },
        updateValue(value) {

            axios.patch('/api/projects/' + this.project.id + '/case_study', {
                phaseId: this.phase.id,
                value: value,
            }).then((response) => {
                if (response.data.success) {
                    if(value) {
                        window.notify.message(response.data.message, 'success');
                    }
                }
            }).catch((error) => {
                window.notify.apiError(error);

                this.watcher();
                this.checkboxValue = !value;
                this.setupWatcher();
            });
        }
    }
}
</script>
